const TOOL_LABEL_IDS: Record<string, string> = {
    // Report tools
    getConsumption: 'aiAgentToolGetConsumption',
    getConsumptionByLocation: 'aiAgentToolAnalyzingLocation',
    getConsumptionByUser: 'aiAgentToolAnalyzingUser',
    getConsumptionByCharger: 'aiAgentToolAnalyzingCharger',
    getConsumptionByCompany: 'aiAgentToolAnalyzingCompany',
    getConsumptionChart: 'aiAgentToolBuildingChart',
    getServiceStatus: 'aiAgentToolCheckingStatus',
    // Data tools
    searchTransactions: 'aiAgentToolSearchingTransactions',
    searchLocations: 'aiAgentToolSearchingLocations',
    searchUsers: 'aiAgentToolSearchingUsers',
    searchChargers: 'aiAgentToolSearchingChargers',
    searchCompanies: 'aiAgentToolSearchingCompanies',
    searchInvoices: 'aiAgentToolSearchingInvoices',
    getLocation: 'aiAgentToolLoadingLocation',
    getUser: 'aiAgentToolLoadingUser',
    getCharger: 'aiAgentToolLoadingCharger',
    getChargerStatus: 'aiAgentToolCheckingChargerStatus',
    getTransaction: 'aiAgentToolLoadingTransaction',
    getActiveTransaction: 'aiAgentToolLoadingActiveSession',
    getPricing: 'aiAgentToolCheckingPricing',
    searchPricingItems: 'aiAgentToolLoadingPriceDetails',
    getInvoice: 'aiAgentToolLoadingInvoice',
    getContract: 'aiAgentToolCheckingContract',
    getTariff: 'aiAgentToolLoadingTariff',
    searchRfidTags: 'aiAgentToolCheckingRfid',
    getCompany: 'aiAgentToolLoadingCompany',
    getRealEstate: 'aiAgentToolLoadingProperty',
    getBusiness: 'aiAgentToolLoadingBusiness',
    getEmployee: 'aiAgentToolLoadingEmployee',
    // Local tools
    convertDate: 'aiAgentToolConvertingDate',
    // Shown while the agent assembles a batch of write actions for one approval.
    planActions: 'aiAgentToolPlanningActions',
};

// Internal tools we don't want to display at all
const SILENT_TOOLS = new Set(['updateSessionTitle']);

export const getToolLabelId = (tool: string): string | null => {
    if (SILENT_TOOLS.has(tool)) return null;
    return TOOL_LABEL_IDS[tool] ?? 'aiAgentToolProcessing';
};
